import {gsap} from "gsap";
import {Back} from "gsap/gsap-core";
import Scroller from "../../Scroller/Scroller";
import Header from "../../Header/Header";

gsap.registerPlugin(Back);

const VideoPlayer = {
    el: null,
    scrollDirection: 1,

    init(el) {
        el = el ? el : $('body');
        this.el = el.find('[component="VideoPlayer"]');
        this.openers = $('[video]');
        if (!this.openers.length) return;

        this.closeBtn = this.el.find('.close');
        this.video = this.el.find('video');
        this.bind();
    },

    bind() {
        this.openers.click((evt) => {
            evt.preventDefault();
            const source = $('<source src="' + WEB_ROOT + $(evt.currentTarget).attr('video')+'" type="video/mp4">');
            source.appendTo(this.video);
            this.video[0].currentTime = 0;
            this.video[0].play();
            this.show();
        })

        this.closeBtn.click((evt) => {
            evt.preventDefault();
            this.hide();
        })
    },

    show() {
        Header.hide();
        Scroller.smoother.paused(true);
        gsap.timeline()
            .to(this.el, {display: 'flex', opacity: 1})
            .to(this.video, {scale: 1, ease:Back.easeInOut}, 0.2)
    },

    hide() {
        Scroller.smoother.paused(false);
        this.video[0].pause();
        this.video.find('source').remove();

        gsap.timeline()
            .to(this.video, {scale: 0.7, ease:Back.easeInOut})
            .to(this.el, {display: 'none', opacity: 0}, 0.2)
    },

}

export default VideoPlayer;